document.addEventListener('DOMContentLoaded', function() {
  const container = document.getElementById('rates');
  if (!container) return; // Exit if container doesn't exist

  const paragraphs = container.querySelectorAll('p.wp-block-kadence-advancedheading');
  const today = new Date();
  const formattedDate = today.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  paragraphs.forEach(p => {
    if (p.textContent.includes('All Rates Effective')) {
      p.textContent = `All Rates Effective ${formattedDate}`;
    }
  });
});
